module.exports = __webpack_public_path__ + "static/media/hushl.ecf82dfe.svg";